import i18n from 'modules/core/lib/i18n'

import AdditionalInformationBlock from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/AdditionalInformation'
import { shouldShowBlock } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/AdditionalInformation/form/schema'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {}

const AdditionalInformation = (props: Props) => {
  const { customizationFields, resourceType, documentType } = props
  const showBlock = shouldShowBlock(customizationFields, resourceType, documentType)

  if (!showBlock) return null

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.additional_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.additional_information_subtitle')}
    >
      <AdditionalInformationBlock {...props} />
    </FormBlock>
  )
}

export default AdditionalInformation
